import { render, staticRenderFns } from "./UbicationView.vue?vue&type=template&id=e468efb6&scoped=true"
import script from "./UbicationView.vue?vue&type=script&lang=js"
export * from "./UbicationView.vue?vue&type=script&lang=js"
import style0 from "./UbicationView.vue?vue&type=style&index=0&id=e468efb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e468efb6",
  null
  
)

export default component.exports